import { render, staticRenderFns } from "./qfSectionHeader.vue?vue&type=template&id=1afa2d77&scoped=true&"
import script from "./qfSectionHeader.vue?vue&type=script&lang=js&"
export * from "./qfSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./qfSectionHeader.vue?vue&type=style&index=0&id=1afa2d77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa2d77",
  null
  
)

export default component.exports